import { render } from "./ProductVariationListItem.vue?vue&type=template&id=7d1ee455&scoped=true&ts=true"
import script from "./ProductVariationListItem.vue?vue&type=script&lang=ts"
export * from "./ProductVariationListItem.vue?vue&type=script&lang=ts"

import "./ProductVariationListItem.vue?vue&type=style&index=0&id=7d1ee455&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1ee455"]])

export default __exports__